import manager from '../Manager';
import ImageCarousel from './ImagePreview/ImageCarousel';
import { isMobile } from 'react-device-detect';

function ImagePreview({ data, index, inEditor, structures }) {
    let images = [];
    if (data.images) {
        images = data.images.filter((image) => image?.image);
    }

    const carouselStyleMobileView = {
        // width: 'auto',//
        width: manager.inEditor ? window.screen.width - 82 : window.screen.width - 32,
        maxWidth: window.screen.width - 32
    }
    return (
        <div className="tbcourse-template tbcourse-template-image" key={index}>
            <div>
                <div className="tbcourse-template-text-title">{data?.title ? data.title : structures.title?.placeholder}</div>
                <div className="tbcourse-template-text-description" dangerouslySetInnerHTML={{ __html: data?.description ? data.description : manager.inEditor ? structures.description.placeholder : '' }}></div>
                <div className="tbcourse-template-images">
                    {images.length === 0 ? (
                        <div className="tbcourse-template-images-item">
                            <span>
                                <img src={require('../assets/img/image-frame.jpg')} className='img-fluid' alt='' />
                            </span>
                        </div>
                    ) : (
                        images.length === 1 ? (
                            <div className="tbcourse-template-images-item">
                                <span style={{ backgroundImage: `url(${images[0].image.fullUrl})` }}>
                                    <img src={images[0].image.fullUrl} className='img-fluid' alt={images[0].image.filename} />
                                </span>
                            </div>
                        ) : (
                            <div
                                className={`tbcourse-template-images-carousel` + (manager.inEditor ? ` editor-view` : ``)}
                                style={isMobile ? carouselStyleMobileView : {}}
                            >
                                <ImageCarousel items={images} />
                                {/* {images.map((item, k) => {
                                    return (
                                        <div className="tbcourse-template-images-item">
                                            <span style={{backgroundImage:`url(${item.image.fullUrl})`}}>
                                                <img src={item.image.fullUrl} className='img-fluidaaa' alt={item.image.filename}/>
                                            </span>
                                        </div>
                                    );
                                })} */}
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    )
}

export default ImagePreview;
